import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmArticle = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "csm-article-page" */ './csm-variants')),
});
